import { Box, useMediaQuery, useTheme } from '@mui/material';
import Chatbot from '../Chatbot/Chatbot';
import { MOBILE_BOTTOM_NAV_OFFSET, MOBILE_CHATBOT_OVERLAY_Z } from '../../config/mobileNavConfig';

/**
 * Mobile-first chatbot shell used by primary nav pages.
 * On viewports below md, reserves space for the fixed bottom navigation bar
 * so the chat composer always sits above it.
 */
const MobileChatbotOverlay = ({ open, setOpen, sidebarOnMd = true }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const useSidebarLayout = sidebarOnMd && isMdUp;

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: MOBILE_CHATBOT_OVERLAY_Z,
        display: 'flex',
        flexDirection: 'column',
        background: useSidebarLayout ? '#181818' : '#E8E9ED',
        color: '#fff',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        ...(useSidebarLayout
          ? {
              top: 0,
              right: 0,
              left: 'auto',
              width: { xs: '100vw', md: 500 },
              maxWidth: '100vw',
              height: { xs: '100dvh', md: '100vh' },
              borderLeft: { md: '4px solid #3a3a3a' },
            }
          : {
              top: 0,
              left: 0,
              right: 0,
              bottom: MOBILE_BOTTOM_NAV_OFFSET,
              width: '100%',
              maxWidth: '100vw',
              height: `calc(100dvh - ${MOBILE_BOTTOM_NAV_OFFSET})`,
              maxHeight: `calc(100dvh - ${MOBILE_BOTTOM_NAV_OFFSET})`,
            }),
      }}
    >
      <Chatbot open={open} setOpen={setOpen} flushBottom={!useSidebarLayout} />
    </Box>
  );
};

export default MobileChatbotOverlay;
